




























































































































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import TestQuestion from "@/store/entities/testQuestion";
import url from "@/lib/url";
//import ewebeditor from "@/components/ewebeditor.vue";
import QuestionOfPaperType from "@/store/entities/questionOfPaperTypes";
import RepeatTestQuestion from "../../testQuestions/testQuestion/repeat-testQuestion.vue";
@Component({
  components: { RepeatTestQuestion },
})
export default class CreateTestQuestion extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  testQuestion: TestQuestion = new TestQuestion();
  repeatModalShow: boolean = false;
  questionOfPaperType: QuestionOfPaperType = new QuestionOfPaperType();
  formTitle: string = "添加试题";
  editorConfig: any = {
    style: 'mini',
    width: '100%',
    height: '100px'
  };
  editorContentConfig: any = {
    style: 'coolblue',
    width: '100%',
    height: '300px'
  };
  frontendurl: string = 'https://manage.sxjy.cq.cn/dist/ewebeditor/';
  editorBackendurl: string = 'https://manage.sxjy.cq.cn/dist/ewebeditor/';
  topicData: any = [];
  isCreate: boolean = true;
  onequestype: string = "";
  keywords: string = "";
  data: any = [];
  valueArray: any = [];
  parentId?: number;
  parentName: string = "一级分类";
  screenWidth: number = document.body.clientWidth - 200;

  pdu: any = [
    { id: "True", value: "对" },
    { id: "False", value: "错" },
  ];
  difficultNamevar: any = [
    { id: 1, value: "易(A)" },
    { id: 2, value: "中(B)" },
    { id: 3, value: "难(C)" },
  ];
  blanksnum: number = 1;
  choicenum: number = 1;
  blanksnumdata: any = [
    //填空
    { id: 1, value: "5项" },
    { id: 2, value: "10项" },
    { id: 3, value: "15项" },
  ];
  choicenumdata: any = [
    //单选
    { id: 1, value: "5项" },
    { id: 2, value: "10项" },
  ];

  newtabdata: any = [
    { id: 0, value: "判断题" },
    { id: 1, value: "单选题" },
    { id: 2, value: "多选题" },
    { id: 3, value: "填空题" },
    { id: 4, value: "计算题" },
    { id: 8, value: "解答题" },
    { id: 9, value: "作文题" },
    { id: 10, value: "探究题" },
    { id: 11, value: "材料题" },
    { id: 12, value: "实践题" },
    { id: 7, value: "选考单选" },
    { id: 5, value: "选考多选" },
    { id: 6, value: "选考计算" },
  ];

  keytype: string = "";
  keychecktype: any = [];

  questionTypeChange(value) {
    this.choicenum = 1;
    this.blanksnum = 1;
    this.testQuestion.questionType = value;
  }
  choicenumChange(value) {
    this.choicenum = value;
    if (value == 2) {
      this.testQuestion.answerKeyF = "";
      this.testQuestion.answerKeyG = "";
      this.testQuestion.answerKeyH = "";
      this.testQuestion.answerKeyI = "";
      this.testQuestion.answerKeyJ = "";
    }
  }
  blanksnumChange(value) {
    this.blanksnum = value;
    if (value < 2) {
      this.testQuestion.answerKeyF = "";
      this.testQuestion.answerKeyG = "";
      this.testQuestion.answerKeyH = "";
      this.testQuestion.answerKeyI = "";
      this.testQuestion.answerKeyJ = "";
    }
    if (value < 3) {
      this.testQuestion.answerKeyK = "";
      this.testQuestion.answerKeyL = "";
      this.testQuestion.answerKeyM = "";
      this.testQuestion.answerKeyN = "";
      this.testQuestion.answerKeyO = "";
    }
  }
  topicOne: any = [];
  topicTwo: any = [];
  uploadActin: string = url + "api/services/app/File/FileGetToken";
  token: string = "Bearer " + window.abp.auth.getToken();
  uploadList: any = [];
  uploadPdfList: any = [];
  questionContent: string = "";
  answerTips: string = "";
  answerKeyA: string = "";
  answerKeyB: string = "";
  answerKeyC: string = "";
  answerKeyD: string = "";
  answerKeyE: string = "";
  answerKeyF: string = "";
  answerKeyG: string = "";
  answerKeyH: string = "";
  answerKeyI: string = "";
  answerKeyJ: string = "";
  answerKeyK: string = "";
  answerKeyL: string = "";
  answerKeyM: string = "";
  answerKeyN: string = "";
  answerKeyO: string = "";
  uploadSuccess(res, file, fileList) {
    this.uploadList = fileList;
  } copy() {
    const clipboard = new Vue.prototype.clipboard(".btn");
    clipboard.on("success", () => {
      this.$Message.success({
        content: "复制成功",
        duration: 1,
      }); //  释放内存

      clipboard.destroy();
    });
    clipboard.on("error", () => {
      this.$Message.error({
        content: "复制失败",
        duration: 1,
      }); //  释放内存

      clipboard.destroy();
    });
  }
  searchebutcount() {
    if (!this.keywords) {
      this.$Message.error("请输入试题内容");
      return false;
    }
    if (
      !this.testQuestion.questionType &&
      this.testQuestion.questionType !== 0
    ) {
      this.$Message.error("请选择试题类型");
      return false;
    }
    this.$store.state.testQuestion.editTestQuestion.questionType =
      this.testQuestion.questionType;
    this.$store.state.testQuestion.editTestQuestion.keyword = this.keywords;
    this.repeatModalShow = true;
  }
  setEditorData_a() {
    (this.$refs["deconmecontent"] as any).setHtmleweb(this.questionContent);
  }
  setEditorData_b() {
    (this.$refs["answerKeyA"] as any).setHtmleweb(this.answerKeyA);
  }
  setEditorData_c() {
    (this.$refs["answerKeyB"] as any).setHtmleweb(this.answerKeyB);
  }
  setEditorData_d() {
    (this.$refs["answerKeyC"] as any).setHtmleweb(this.answerKeyC);
  }
  setEditorData_e() {
    (this.$refs["answerKeyD"] as any).setHtmleweb(this.answerKeyD);
  }
  setEditorData_f() {
    (this.$refs["answerKeyE"] as any).setHtmleweb(this.answerKeyE);
  }
  setEditorData_h() {
    if (this.testQuestion.answerKeyF) {
      (this.$refs["answerKeyF"] as any).setHtmleweb(this.answerKeyF);
    }
  }

  setEditorData_i() {
    if (this.testQuestion.answerKeyG) {
      (this.$refs["answerKeyG"] as any).setHtmleweb(this.answerKeyG);
    }
  }
  setEditorData_j() {
    if (this.testQuestion.answerKeyH) {
      (this.$refs["answerKeyH"] as any).setHtmleweb(this.answerKeyH);
    }
  }
  setEditorData_k() {
    if (this.testQuestion.answerKeyI) {
      (this.$refs["answerKeyI"] as any).setHtmleweb(this.answerKeyI);
    }
  }
  setEditorData_l() {
    if (this.testQuestion.answerKeyJ) {
      (this.$refs["answerKeyJ"] as any).setHtmleweb(this.answerKeyJ);
    }
  }
  setEditorData_m() {
    if (this.testQuestion.answerKeyK) {
      (this.$refs["answerKeyK"] as any).setHtmleweb(this.answerKeyK);
    }
  }
  setEditorData_n() {
    if (this.testQuestion.answerKeyL) {
      (this.$refs["answerKeyL"] as any).setHtmleweb(this.answerKeyL);
    }
  }
  setEditorData_o() {
    if (this.testQuestion.answerKeyM) {
      (this.$refs["answerKeyM"] as any).setHtmleweb(this.answerKeyM);
    }
  }
  setEditorData_p() {
    if (this.testQuestion.answerKeyN) {
      (this.$refs["answerKeyN"] as any).setHtmleweb(this.answerKeyN);
    }
  }
  setEditorData_q() {
    if (this.testQuestion.answerKeyO) {
      (this.$refs["answerKeyO"] as any).setHtmleweb(this.answerKeyO);
    }
  }

  setEditorData_g() {
    (this.$refs["answerTips"] as any).setHtmleweb(this.answerTips);
  }

  setEditorDataInit() {
    (this.$refs["deconmecontent"] as any).setHtmleweb("");
    (this.$refs["answerTips"] as any).setHtmleweb("");
    (this.$refs["answerKeyA"] as any).setHtmleweb("");
    (this.$refs["answerKeyB"] as any).setHtmleweb("");
    (this.$refs["answerKeyC"] as any).setHtmleweb("");
    (this.$refs["answerKeyD"] as any).setHtmleweb("");
    (this.$refs["answerKeyE"] as any).setHtmleweb("");
    if (
      this.testQuestion.questionType == 1 ||
      this.testQuestion.questionType == 3
    ) {
      (this.$refs["answerKeyF"] as any).setHtmleweb("");
      (this.$refs["answerKeyG"] as any).setHtmleweb("");
      (this.$refs["answerKeyH"] as any).setHtmleweb("");
      (this.$refs["answerKeyI"] as any).setHtmleweb("");
      (this.$refs["answerKeyJ"] as any).setHtmleweb("");
    }
    if (this.testQuestion.questionType == 3) {
      (this.$refs["answerKeyK"] as any).setHtmleweb("");
      (this.$refs["answerKeyL"] as any).setHtmleweb("");
      (this.$refs["answerKeyM"] as any).setHtmleweb("");
      (this.$refs["answerKeyN"] as any).setHtmleweb("");
      (this.$refs["answerKeyO"] as any).setHtmleweb("");
    }
  }
  removefilterHtmlbr(value) {
    if (value) {
      let content = value
        .replace(/^(<[Bb][Rr]*?.*?\/?\s*?>)+/, "")
        .replace(/(<[Bb][Rr]*?.*?\/?\s*?>)+$/g, "");
      var deline = content.replace(
        /<span\sstyle="text-decoration-line:\sunderline[\s\S]*?>([\s\S]*?)<\/span>/gi,
        "<u>&nbsp;&nbsp;$1&nbsp;&nbsp;</u>"
      );
      return deline;
    } else {
      return value
    }

  }
  getQuestionContent() {
    this.testQuestion.questionContent = this.removefilterHtmlbr(
      this.testQuestion.questionContent
    );
    this.testQuestion.answerTips = this.removefilterHtmlbr(
      this.testQuestion.answerTips
    );
    if (this.testQuestion.questionType > 0) {
      this.testQuestion.answerKeyA = this.removefilterHtmlbr(
        this.testQuestion.answerKeyA
      );
      this.testQuestion.answerKeyB = this.removefilterHtmlbr(
        this.testQuestion.answerKeyB
      );
      this.testQuestion.answerKeyC = this.removefilterHtmlbr(
        this.testQuestion.answerKeyC
      );
      this.testQuestion.answerKeyD = this.removefilterHtmlbr(
        this.testQuestion.answerKeyD
      );
      this.testQuestion.answerKeyE = this.removefilterHtmlbr(
        this.testQuestion.answerKeyE
      );
    }
    if (
      this.testQuestion.questionType == 1 ||
      this.testQuestion.questionType == 3
    ) {
      if (this.blanksnum >= 2 || this.choicenum == 2) {
        this.testQuestion.answerKeyF = this.removefilterHtmlbr(
          this.testQuestion.answerKeyF
        );
        this.testQuestion.answerKeyG = this.removefilterHtmlbr(
          this.testQuestion.answerKeyG
        );
        this.testQuestion.answerKeyH = this.removefilterHtmlbr(
          this.testQuestion.answerKeyH
        );
        this.testQuestion.answerKeyI = this.removefilterHtmlbr(
          this.testQuestion.answerKeyI
        );
        this.testQuestion.answerKeyJ = this.removefilterHtmlbr(
          this.testQuestion.answerKeyJ
        );
      }
    }
    if (this.testQuestion.questionType == 3) {
      if (this.blanksnum > 2) {
        this.testQuestion.answerKeyK = this.removefilterHtmlbr(
          this.testQuestion.answerKeyK
        );
        this.testQuestion.answerKeyL = this.removefilterHtmlbr(
          this.testQuestion.answerKeyL
        );
        this.testQuestion.answerKeyM = this.removefilterHtmlbr(
          this.testQuestion.answerKeyM
        );
        this.testQuestion.answerKeyN = this.removefilterHtmlbr(
          this.testQuestion.answerKeyN
        );
        this.testQuestion.answerKeyO = this.removefilterHtmlbr(
          this.testQuestion.answerKeyO
        );
      }
    }
  }
  handleRemove(file, fileList) {
    this.uploadList = fileList;
  }
  handleMaxSize(file) {
    this.$Notice.warning({
      title: "超出文件大小限制",
      desc: "文件【" + file.name + "】 太大, 不能超过50M.",
    });
  }

  cascaderSelect(value, selectedData) {
    if (selectedData.length > 0)
      this.testQuestion.sectionId = selectedData[selectedData.length - 1].id;
    else this.testQuestion.sectionId = null;
  }
  save() {
    (this.$refs.testQuestionForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.valueArray.length > 0) {
          if (this.valueArray.length < 4) {
            this.$Message.warning("学科未选择到末级!");
            return false;
          }
        } else {
          this.$Message.warning("请选择试题学科");
          return false;
        }
        if (!this.testQuestion.degreeDifficulty) {
          this.$Message.warning("请选择试题难度");
          return false;
        }
        if (
          !this.testQuestion.questionType &&
          this.testQuestion.questionType !== 0
        ) {
          this.$Message.warning("请选择试题类型");
          return false;
        }

        this.getQuestionContent();
        if (
          this.testQuestion.questionType == 1 ||
          this.testQuestion.questionType == 2 ||
          this.testQuestion.questionType == 5 ||
          this.testQuestion.questionType == 7
        ) {
          if (
            this.testQuestion.questionType == 1 ||
            this.testQuestion.questionType == 7
          ) {
            this.testQuestion.correctAnswer = this.keytype;
          } else {
            this.testQuestion.correctAnswer = this.keychecktype.sort().join(",");
          }
        } else {
          if (
            !this.testQuestion.answerKeyA &&
            this.testQuestion.questionType != 0
          ) {
            this.$Message.warning("至少有一个答案，并从第一个开始");
            return false;
          } else if (this.testQuestion.questionType == 0) {
            this.testQuestion.correctAnswer = this.onequestype;
          } else {
            this.testQuestion.correctAnswer = this.testQuestion.answerKeyA;
          }
          if (this.testQuestion.answerKeyB) {
            this.testQuestion.correctAnswer +=
              "\r\n" + this.testQuestion.answerKeyB;
          }
          if (this.testQuestion.answerKeyC) {
            this.testQuestion.correctAnswer +=
              "\r\n" + this.testQuestion.answerKeyC;
          }
          if (this.testQuestion.answerKeyD) {
            this.testQuestion.correctAnswer +=
              "\r\n" + this.testQuestion.answerKeyD;
          }
          if (this.testQuestion.answerKeyE) {
            this.testQuestion.correctAnswer +=
              "\r\n" + this.testQuestion.answerKeyE;
          }
          if (this.testQuestion.questionType == 3) {
            //填空题 正确答案后10空
            if (this.testQuestion.answerKeyF) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyF;
            }
            if (this.testQuestion.answerKeyG) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyG;
            }
            if (this.testQuestion.answerKeyH) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyH;
            }
            if (this.testQuestion.answerKeyI) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyI;
            }
            if (this.testQuestion.answerKeyJ) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyJ;
            }
            if (this.testQuestion.answerKeyK) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyK;
            }
            if (this.testQuestion.answerKeyL) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyL;
            }
            if (this.testQuestion.answerKeyM) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyM;
            }
            if (this.testQuestion.answerKeyN) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyN;
            }
            if (this.testQuestion.answerKeyO) {
              this.testQuestion.correctAnswer +=
                "\r\n" + this.testQuestion.answerKeyO;
            } //填空题 正确答案后10空
          }
        }
        if (!this.testQuestion.questionContent) {
          this.$Message.warning("请填写试题内容");
          return false;
        }
        if (!this.testQuestion.answerKeyA && this.testQuestion.questionType) {
          this.$Message.warning("请填写答案内容");
          return false;
        }
        if (this.testQuestion.questionType == 0) {
          if (!this.onequestype) {
            this.$Message.warning("请设置正确答案");
            return false;
          }
        }
        if (
          this.testQuestion.questionType == 1 ||
          this.testQuestion.questionType == 2 ||
          this.testQuestion.questionType == 5 ||
          this.testQuestion.questionType == 7
        ) {
          if (
            !this.testQuestion.correctAnswer ||
            this.testQuestion.correctAnswer.length < 1
          ) {
            this.$Message.warning("请设置正确答案");
            return false;
          }
        }
        if (
          this.testQuestion.questionType == 2 ||
          this.testQuestion.questionType == 5
        ) {
          if (this.testQuestion.correctAnswer.length < 3) {
            this.$Message.warning("请至少选择两个正确答案");
            return false;
          }
        }
        this.testQuestion.gradeType = 0;
        let sendType = "testQuestion/create";
        this.$store
          .dispatch({
            type: sendType,
            data: this.testQuestion,
          })
          .then((result) => {
            this.questionOfPaperType.questionDetail.imported.push(result);
            this.importQuestion();
            // this.getpaper();
            this.keytype = "";
            this.keychecktype = [];
            this.onequestype = "";
            (this.$refs["deconmecontent"] as any).setHtmleweb("");
            (this.$refs["answerTips"] as any).setHtmleweb("");
            if (this.testQuestion.questionType > 0) {
              this.testQuestion.correctAnswer = "";
              this.testQuestion.answerKeyA = "";
              this.testQuestion.answerKeyB = "";
              this.testQuestion.answerKeyC = "";
              this.testQuestion.answerKeyD = "";
              this.testQuestion.answerKeyE = "";
              if (this.blanksnum >= 2 || this.choicenum == 2) {
                this.testQuestion.answerKeyF = "";
                this.testQuestion.answerKeyG = "";
                this.testQuestion.answerKeyH = "";
                this.testQuestion.answerKeyI = "";
                this.testQuestion.answerKeyJ = "";
              }
              if (this.blanksnum > 2) {
                this.testQuestion.answerKeyK = "";
                this.testQuestion.answerKeyL = "";
                this.testQuestion.answerKeyM = "";
                this.testQuestion.answerKeyN = "";
                this.testQuestion.answerKeyO = "";
              }
            } else {
              this.testQuestion.correctAnswer = "";
            }
          })
          .catch((result) => { });
        // } else {
        //  this.$Message.warning("试题内容和答案不能为空");
        // }
      }
    });
  }
  importQuestion() {
    this.$store
      .dispatch({
        type: "testPaper/importQuestionadd",
        data: this.questionOfPaperType,
      })
      .then((res) => {
        if (res.success) {
          this.getpaper();
        }
      })
      .catch((err) => { });
  }
  getpaper() {
    this.$store
      .dispatch({
        type: "testPaper/getadd",
        data: { id: this.questionOfPaperType.id },
      })
      .then((res) => {
        //  console.log(res);
        this.$store.state.editTestPaper = res;
        // console.log(this.$store.state.editTestPaper);
        this.$emit("save-success");
        this.$emit("input", false);
      })
      .catch((err) => { });
  }
  cancel() {
    this.visibleChange(false);
  }

  udata() {
    let udata = this.$store.state.testPaper.cascaders.items;
    let valueArrayb = this.$store.state.testPaper.editTestPaper.categoryList;
    let temp = [];
    if (valueArrayb.length > 0) {
      this.testQuestion.sectionId = Number(valueArrayb[valueArrayb.length - 1]);
      udata.forEach((item, index, arr) => {
        if (item.id === valueArrayb[0]) {
          temp = arr[index];
        }
      });
    }
    this.data = [];
    this.data.push(temp);
    if (this.data.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  visibleChange(value: boolean) {
    this.choicenum = 1;
    this.blanksnum = 1;
    if (!value) {
      this.testQuestion = new TestQuestion();
      (this.$refs.testQuestionForm as any).resetFields();
      this.$emit("input", value);
    } else {
      /**this.data = this.$store.state.testPaper.cascaders.items;
      this.valueArray = this.$store.state.testPaper.editTestPaper.categoryList;
      let temp = [];
      if (this.valueArray.length > 0) {
        this.testQuestion.sectionId =
          this.valueArray[this.valueArray.length - 1];
        this.data.forEach((item, index, arr) => {
          if (item.id === this.valueArray[0]) {
            temp = arr[index];
          }
        });
      }
      this.data = [];
      this.data.push(temp);
      */
      if (this.udata()) {
        setTimeout(() => {
          this.valueArray =
            this.$store.state.testPaper.editTestPaper.categoryList;
        }, 1000);
      }
      this.questionOfPaperType =
        this.$store.state.testPaper.questionOfPaperType;
      this.testQuestion.questionType = this.questionOfPaperType.questionType;
      this.testQuestion.degreeDifficulty =
        this.questionOfPaperType.questionDetail.degreeDifficulty;
      // this.setEditorDataInit();
    }
  }
  createInit() {
    this.valueArray = [];
    this.keytype = "";
    this.keychecktype = [];
  }
}
